import { ActionType, createReducer } from 'typesafe-actions';

import * as userActions from './actions';
import { userInitialState } from './initialState';

type State = typeof userInitialState;
type Actions = ActionType<typeof userActions>;

export const userReducer = createReducer<State, Actions>(userInitialState)
  .handleAction(userActions.actionGetCurrentUser, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(userActions.actionSuccessGetCurrentUser, (state, action) => ({
    ...state,
    ...action.payload,
    availableFeatures: {
      ...action.payload.availableFeatures,
    },
    loading: false,
  }))
  .handleAction(userActions.actionErrorGetCurrentUser, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
  .handleAction(userActions.actionSuccessGetCustomerSettings, (state, action) => ({
    ...state,
    priceType: action.payload.priceType || state.priceType,
  }))
  .handleAction(userActions.actionChangePriceType, (state, action) => ({
    ...state,
    priceType: action.payload,
  }))
  .handleAction(userActions.actionLoadingGetVerificationLimits, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(userActions.actionSuccessGetVerificationLimits, (state, action) => ({
    ...state,
    verificationLimits: action.payload,
    loading: false,
  }))
  .handleAction(userActions.actionErrorGetVerificationLimits, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
  .handleAction(userActions.actionSuccessGetCustomerTier, (state, action) => ({
    ...state,
    tier: {
      ...state.tier,
      currentTier: action.payload.currentTier,
      totalExperiencePoints: action.payload.totalExperiencePoints,
    },
    loading: false,
  }))
  .handleAction(userActions.actionSuccessGetTiers, (state, action) => ({
    ...state,
    tiers: action.payload,
    loading: false,
  }))
  .handleAction(userActions.actionSuccessGetSettings, (state, action) => ({
    ...state,
    settings: action.payload,
    loading: false,
  }))
  .handleAction(userActions.actionSuccessGetVerificationLevel, (state, action) => ({
    ...state,
    intermediateVerificationLevelStatus: action.payload,
  }));
